import type { PlanoTrabalho } from '../types/planoTrabalho.types';

/** Plano em análise sem movimentação há mais que isso é tratado como parado. */
export const DIAS_PLANO_PARADO = 15;

const MS_POR_DIA = 24 * 60 * 60 * 1000;
// Rascunho ainda não entrou no fluxo; os demais já saíram dele.
const STATUS_FORA_DO_FLUXO = ['RASCUNHO', 'APROVADO', 'REPROVADO', 'CONCLUIDO', 'FECHADO'];

export const diasParado = (plano: PlanoTrabalho, agora = Date.now()): number | null => {
  if (!plano.dataAtualizacao) return null;
  const t = new Date(plano.dataAtualizacao).getTime();
  return Number.isNaN(t) ? null : Math.floor((agora - t) / MS_POR_DIA);
};

export const planosParados = (planos: PlanoTrabalho[], agora = Date.now()): PlanoTrabalho[] =>
  planos.filter(p => {
    if (STATUS_FORA_DO_FLUXO.includes(p.status || '')) return false;
    const dias = diasParado(p, agora);
    return dias != null && dias >= DIAS_PLANO_PARADO;
  });
